import { ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import GroupIcon from '@mui/icons-material/Group';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import DesktopAccessDisabledIcon from '@mui/icons-material/DesktopAccessDisabled';
import { AuthContext } from "../../../contexts/AuthContext";
import { useContext } from "react";

import SyncIcon from '@mui/icons-material/Sync';

export default function MenuConfig({ openHeader, handleClose, ...props }) {
    const navigate = useNavigate()
    const { user } = useContext(AuthContext);
    const permissionGrupos = [];
    const permissionUser = [];

    user?.permission?.map((el) => {
        if (el.name == "Grupos de permissão") {
            permissionGrupos.push(...el.permission);
        }
        if (el.name == "Usuários") {
            permissionUser.push(...el.permission);
        }
    });
    return (
        <Menu
            id="basic-menu"
            transformOrigin={{ horizontal: 'left', vertical: 'center' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
            {...props}
            PaperProps={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                elevation: 0,
                sx: {
                    background: openHeader ? "#2c4992" : "#00a7e1",
                    color: openHeader ? "#ffffff" : "#2c4992",
                    overflow: 'visible',
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                },
            }}>
            {user?.id_client == 25886008 &&
                <>
                    {!!permissionGrupos.find((el) => el.name == "Visualizar") && (
                        <MenuItem onClick={() => { handleClose(); navigate("/permission") }}>
                            <ListItemIcon>
                                <DesktopAccessDisabledIcon sx={{ color: openHeader ? "#ffffff" : "#2c4992" }} />
                            </ListItemIcon>Permissões</MenuItem>

                    )}
                    {user?.master == 1 && (
                        <>
                            <MenuItem onClick={() => { handleClose(); navigate("/clients") }}>
                                <ListItemIcon>
                                    <BusinessCenterIcon sx={{ color: openHeader ? "#ffffff" : "#2c4992" }} />
                                </ListItemIcon>Clientes
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); navigate("/synchronize") }}>
                                <ListItemIcon>
                                    <SyncIcon sx={{ color: openHeader ? "#ffffff" : "#2c4992" }} />
                                </ListItemIcon>Sincronização
                            </MenuItem>
                        </>

                    )}
                </>
            }
            {!!permissionUser.find((el) => el.name == "Visualizar") && (

                <MenuItem onClick={() => { handleClose(); navigate("/users") }}>
                    <ListItemIcon>
                        <GroupIcon sx={{ color: openHeader ? "#ffffff" : "#2c4992" }} />
                    </ListItemIcon>Usuários</MenuItem>
            )}
        </Menu>
    )
}